import { FC, useMemo } from 'react';
import { Property } from 'csstype';
import { MAX_AD_BID_BUDGET } from '../configs';
import { CurrencySuffix } from 'components/CurrencySuffix';
import { Progress } from 'antd';

type TProgressBarTypes = 'spent' | 'current_budget' | 'new_budget';

export const BudgetProgressBar: FC<{ value: number; type: TProgressBarTypes }> = ({ value = 0, type }) => {
	// ! memos
	const strokeColor = useMemo(() => {
		const config: Record<TProgressBarTypes, Property.Color | undefined> = {
			spent: 'var(--ant-red-6)',
			current_budget: undefined,
			new_budget: 'var(--ant-green-7)',
		};

		return config[type];
	}, [type]);

	// ! render
	return (
		<Progress
			percent={(100 * value) / MAX_AD_BID_BUDGET}
			strokeColor={strokeColor}
			format={(per = 0) => {
				const value = (per * MAX_AD_BID_BUDGET) / 100;

				const value2decimal = Math.round(value * 100) / 100;

				return <CurrencySuffix>{value2decimal}</CurrencySuffix>;
			}}
			size={{ height: 20 }}
			percentPosition={{ align: 'center', type: 'inner' }}
		/>
	);
};
